<template>
  <div>
    <ValidationObserver ref="loginForm" slim>
      <b-form @submit.prevent="send" class="clearfix mb-3" novalidate="novalidate">
        <ValidationProvider
            name="Nume Agentie"
            :rules="{ required: true }"
            v-slot="vContext"
          >
          <b-form-group
            label="Nume Agentie:"
            label-class="font-weight-bold pt-0"
            label-for="agency">
            <b-input-group>
              <b-input-group-prepend is-text class="login-form-prepend">
                <b-icon icon="house-fill" font-scale="0.8"></b-icon>
              </b-input-group-prepend>
              <b-input
                type="text"
                name="agency"
                id="agency"
                v-model="register.agency"
                placeholder="nume agentie"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="agency"
              />
              <b-form-invalid-feedback id="agency">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
            name="Cod Unic Inregistrare"
            :rules="{ required: true }"
            v-slot="vContext"
          >
          <b-form-group
            label="CUI:"
            label-class="font-weight-bold pt-0"
            label-for="vat">
            <b-input-group>
              <b-input-group-prepend is-text class="login-form-prepend">
                <b-icon icon="hash" font-scale="0.8"></b-icon>
              </b-input-group-prepend>
              <b-input
                type="text"
                name="cui"
                id="vat"
                v-model="register.vat"
                placeholder="cod unic inregistrare"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="cui"
              />
              <b-form-invalid-feedback id="cui">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          name="Email"
          :rules="{required: true}"
          v-slot="vContext"
        >
          <b-form-group label="Email:"
            label-class="font-weight-bold pt-0"
            label-for="Adresa">
            <b-input-group>
              <b-input-group-prepend is-text class="login-form-prepend">
                <b-icon icon="envelope-fill" font-scale="0.8"></b-icon>
              </b-input-group-prepend>
              <b-input
                type="email"
                name="email"
                id="email"
                v-model="register.email"
                placeholder="email"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="email"
              />
              <b-form-invalid-feedback id="email">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          name="Telefon"
          :rules="{required: true}"
          v-slot="vContext"
        >
          <b-form-group
            label="Telefon:"
            label-class="font-weight-bold pt-0"
            label-for="telefon">
            <b-input-group>
              <b-input-group-prepend is-text class="login-form-prepend">
                <b-icon icon="phone" font-scale="0.8"></b-icon>
              </b-input-group-prepend>
              <b-input
                type="text"
                name="telefon"
                id="telefon"
                v-model="register.phone"
                placeholder="telefon"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="phone"
              />
              <b-form-invalid-feedback id="phone">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          name="Nume contact"
          :rules="{required: true}"
          v-slot="vContext"
        >
          <b-form-group
            label="Nume contact:"
            label-class="font-weight-bold pt-0"
            label-for="nume">
            <b-input-group>
              <b-input-group-prepend is-text class="login-form-prepend">
                <b-icon icon="person-square" font-scale="0.8"></b-icon>
              </b-input-group-prepend>
              <b-input
                type="text"
                name="nume"
                id="nume"
                v-model="register.name"
                placeholder="nume contact"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="agent_name"
              />
              <b-form-invalid-feedback id="agent_name">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          name="Adresa agentie"
          :rules="{required: true}"
          v-slot="vContext"
        >
          <b-form-group
            label="Adresa agentie:"
            label-class="font-weight-bold pt-0"
            label-for="adresa">
            <b-input-group>
              <b-input-group-prepend is-text class="login-form-prepend">
                <b-icon icon="geo-alt" font-scale="0.8"></b-icon>
              </b-input-group-prepend>
              <b-input
                type="text"
                name="adresa"
                id="adresa"
                v-model="register.address"
                placeholder="adresa agentie"
                size="sm"
                :state="getValidationState(vContext)"
                aria-describedby="address"
              />
              <b-form-invalid-feedback id="address">{{ vContext.errors[0] }}</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </ValidationProvider>
        <div class="clearfix">
          <b-button type="submit" variant="outline-primary" class="float-right btn-sm">
            <b-icon icon="caret-right-fill" class="mr-2"></b-icon>
            <b>TRIMITE</b>
          </b-button>
        </div>
        <hr class="my-2"/>
        <small class="text-center py-1 float-right">
          Pentru login
          <router-link :to="{ name: 'Public/Login' }" class="link">click aici</router-link>
        </small>
      </b-form>
    </ValidationObserver>

    <b-modal id="success" hide-header hide-footer v-model="modalSuccess" >
      <template v-if="subscribeSuccess">
        <div class="d-flex align-item-center justify-content-center">
          <div class="pt-4">
            <p class="d-flex align-item-center justify-content-center">
              <b-iconstack font-scale="5" animation="throb">
                <b-icon stacked icon="check2" variant="success" scale="0.75"></b-icon>
                <b-icon stacked icon="circle" variant="success"></b-icon>
              </b-iconstack>
              <!-- <b-icon icon="check2" animation="throb" font-scale="8" class="text-success"></b-icon> -->
            </p>
            <h4 class="text-center">Datele au fost trimise cu success</h4>
          </div>
        </div>
        <hr>
        <p class="my-4 text-center">
          <router-link :to="{ name: 'Public/Login' }" class="btn btn-outline-primary px-5">
            <b-icon icon="lock-fill" class="mr-2"></b-icon>Login
          </router-link>
        </p>
      </template>
      <template v-else>
        <div class="d-flex align-item-center justify-content-center">
          <div class="pt-4">
            <p class="d-flex align-item-center justify-content-center">
              <b-icon icon="slash-circle" animation="throb" font-scale="8" class="text-danger"></b-icon>
            </p>
            <h5 class="text-center">Ne cerem scuze, a aparut o erroare in transmiterea datelor. Va rugam incercati din nou.</h5>
          </div>
        </div>
        <hr>
        <p class="my-4 text-center">
          <b-button @click="closeModal" class="px-5" variant="outline-primary"> Inchide </b-button>
        </p>
      </template>
    </b-modal>
  </div>
</template>

<script>
import validation from 'b2b-common/mixins/validation'
import { register } from 'b2b-common/services/public'
import toast from 'b2b-common/mixins/toast'

export default {
  name: 'Subscribe',
  mixins: [validation, toast],
  data () {
    return {
      register: {
        agency: '',
        vat: '',
        email: '',
        phone: '',
        name: '',
        address: '',
        regcom: ''
      },
      modalSuccess: false,
      subscribeSuccess: true
    }
  },
  methods: {
    send () {
      this.$refs.loginForm.validate().then(success => {
        if (!success) {
          this.addToast({ title: 'Formular invalid', message: 'Va rugam completati toate campurile obligatorii!', variant: 'danger' })
        } else {
          register(this.register).then(res => {
            if (res !== 'OK') this.subscribeSuccess = false
            this.modalSuccess = true
          })
        }
      })
    },
    closeModal () {
      this.modalSuccess = false
    }
  }
}
</script>
